import { OutlinedFlag  } from '@mui/icons-material';
import RolesAndRights from './RolesAndRights';


export default {
    icon: OutlinedFlag,
    recordRepresentation: 'reference',
    list: RolesAndRights
};
